export function Logo({ compact = false, light = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="app-logo">
      <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-white shadow-sm ring-1 ring-black/5">
        <img src="/foresee-mark.png" alt="Foresee" className="h-7 w-7 object-contain" />
      </div>
      {!compact && (
        <div className="leading-tight">
          <div className={`font-heading text-[15px] font-bold tracking-tight ${light ? "text-white" : "text-foreground"}`}>Foresee</div>
          <div className={`text-[9px] font-semibold uppercase tracking-[0.22em] ${light ? "text-white/50" : "text-[hsl(var(--accent))]"}`}>Beyond Compliance</div>
        </div>
      )}
    </div>
  );
}

export const PRIORITY_STYLES = {
  high: "bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/20",
  medium: "bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20",
  low: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20",
};

export const STATUS_STYLES = {
  new: "bg-blue-500/10 text-blue-600 dark:text-blue-400",
  in_review: "bg-violet-500/10 text-violet-600 dark:text-violet-400",
  actioned: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
  open: "bg-blue-500/10 text-blue-600 dark:text-blue-400",
  in_progress: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
  closed: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
};

export function scoreColor(v) {
  if (v >= 85) return "#10b981";
  if (v >= 70) return "#f59e0b";
  return "#ef4444";
}

export function timeAgo(iso) {
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export function StatCard({ icon: Icon, label, value, sub, tone = "bg-secondary text-[hsl(var(--accent))]" }) {
  return (
    <div className="rounded-2xl border border-border bg-card p-5">
      <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${tone}`}>
        {Icon && <Icon className="h-5 w-5" />}
      </div>
      <div className="mt-3 font-heading text-2xl font-bold tracking-tight">{value}</div>
      <div className="text-sm text-muted-foreground">{label}</div>
      {sub && <div className="mt-0.5 text-xs text-muted-foreground">{sub}</div>}
    </div>
  );
}

export const MODULE_LABELS = {
  report: "Report Issue", reports: "Reports", actions: "Actions", assistant: "AI Assistant",
  resources: "Resource Library", iso: "ISO Compliance", training: "Training", esg: "ESG",
  contractors: "Contractors", analytics: "Analytics", marketplace: "Marketplace",
};
